export const CAPTCHA_SITE_KEY = process.env.YANDEX_CAPTCHA_KEY || ''
